module.exports = __webpack_public_path__ + "img/chart-candle-dark-grey.46524046.svg";